const initialState = {
  headerData: null,
  subNavData: null,
  articleData: null,
  selectedHeaderData: null,
  redirectUrlData: null,
  loading: null,
  error: null,
  location: null,
  locationError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // case "HEADER_DATA":
    //   return {
    //     ...state,
    //     headerData: action.payload,
    //   };
    case "SUBNAV_DATA":
      return {
        ...state,
        subNavData: action.payload,
      };
    case "SELECTED_HEADER_DATA":
      return {
        ...state,
        selectedHeaderData: action.payload,
      };
    case "REDIRECT_URL":
      return {
        ...state,
        redirectUrlData: action.payload,
      };
    case "LOADING":
      return {
        ...state,
        loading: true,
      };
    case "GET_HEADER_DATA_SUCCESS":
      return {
        ...state,
        headerData: action.payload,
        loading: false,
      };

    case "GET_HEADER_DATA_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "GET_LOCATION_SUCCESS":
      return {
        ...state,
        location: action.payload,
      };
    case "GET_LOCATION_FAILURE":
      return {
        ...state,
        locationError: action.payload,
      };
    default:
      return state;
  }
};
